<template>
  <div class="shareask">
    <Header :white="true" :center="true"/>
    <div class="prompt_wrap">
      <h2>Thank you! Share the video now in just two clicks:</h2>
      <div class="button_wrap">
        <button class="btn facebook" @click="shareFacebook">Share on Facebook</button>
        <button class="btn whatsapp" @click="shareWhatsapp">Share on WhatsApp</button>
      </div>
      <div class="share-preview">
        <img class="share-preview-img" src="../assets/share.png">
        <div class="share-preview-content">
          <div
            class="share-preview-title"
          >Add your name: 2 years on from Grenfell, make homes safe &gt;&gt;</div>
          <div class="share-preview-desc">Watch, share &amp; join us. #DemandChange</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";

export default {
  name: "Share",
  props: ["gotoSlide", "analytics"],
  components: {
    Header
  },
  methods: {
    shareFacebook() {
      var toShareUrl = "https://support.grenfellunited.org/share.php/";
      var shareURL =
        "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(toShareUrl);
      window.open(
        shareURL,
        "_blank",
        "toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250,top=300,left=300"
      );
      this.analytics("Facebook", "Shared");
      this.gotoSlide(3);
    },
    shareWhatsapp() {
      var here =
        "https://support.grenfellunited.org/?utm_campaign=grenfell-united&utm_medium=whatsapp&source=whatsapp";
      var shareText =
        "I'm supporting Grenfell United, the survivors and bereaved families from the Grenfell tower fire. We need to make change so something like this never happens again. Check out their new campaign video here: " +
        here;

      var shareURL =
        "https://api.whatsapp.com/send?text=" + encodeURIComponent(shareText);
      window.open(shareURL, "_blank");
      this.analytics("WhatsApp", "Shared");
      this.gotoSlide(3);
    }
  }
};
</script>

<!-- #B3D234 -->
<style scoped lang="scss">
.shareask {
  width: 100%;
  min-height: 100vh;
  background-image: url("../assets/Grenfell1Yr_0004_A.jpg");
  background-size: cover;
  padding-bottom: 20px;
  padding-top: 10px;
  @media only screen and (max-width: 767px) {
    padding: 10px;
  }
  .prompt_wrap {
    width: 100%;
    max-width: 800px;
    background: #fff;
    padding: 40px 40px;
    margin: 0 auto;
    border-radius: 5px;
    margin: 20px auto 0;
    text-align: center;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    @media only screen and (max-width: 767px) {
      padding: 30px 20px 20px;
      margin: 10px auto 0;
    }
    h2 {
      margin: 0 40px 10px;
      @media only screen and (max-width: 767px) {
        font-size: 22px;
      }
    }
    p {
      letter-spacing: 0.5px;
      line-height: 1.5;
      font-weight: 500;
      font-size: 18px;
    }
    .share-preview {
      width: 100%;
      max-width: 500px;
      border: solid 1px #979797;
      margin: 30px auto 0;
      border-radius: 4px;
      .share-preview-img {
        width: 100%;
      }
      .share-preview-content {
        padding: 15px;
        text-align: left;
        .share-preview-title {
          font-size: 18px;
          font-family: "Arial", sans-serif;
          text-align: left;
          margin-bottom: 7px;
          font-weight: 600;
        }
        .share-preview-desc {
          font-size: 14px;
          font-family: "Arial", sans-serif;
          text-align: left;
        }
      }
    }
  }
}
</style>
